<template>
  <div>
    <button @click="init" class="btn btn-sm btn-danger mb-4">Обновить</button>
    <div class="row" v-if="date">
      <div class="col-6">
        <label>Дата</label>
        <datetime v-model="date" @input="init" class="from-control" type="date" format="dd/MM/yyyy">
        </datetime>
      </div>
    </div>
    <ListMap 
      :cardLink="`item_shop`" 
      v-if="done === true && points.length" 
      :points="points" 
      :defaultLat="lstLat" 
      :defaultLon="lstLon"
      :params="{ user_id: id }" 
      :polyline="{ color: 'blue', latlngs: data }" />
    <div v-else-if="!points.length">
      <div class="text-x4-b m-t-5">Посещении нет на выбранную дату</div>
    </div>
  </div>
</template>
<script>
import ListMap from './ListMap';
export default {
  data() {
    return {
      points: [],
      data: [],
      lstLat: 0,
      lstLon: 0,
      date: new Date().toISOString(),
      done: false,
    };
  },
  components: {
    ListMap
  },
  props: {
    id: {
      default: null,
    }
  },
  created() {
    if(this.$route.query['date'])
      this.date = new Date(this.$route.query['date']).toISOString()
    this.init();
  },
  methods: {
    init() {
      this.$loading(true);
      this.$http.get(`users/${this.id}/points`, { params: { date: this.date.split('T')[0] } }).then(response => {

        try {
          const content = response.data;
          const data = content.data;
          this.points = response.data.data
          if (data.length) {
            for (let i = 0; i < data.length; i++) {
              this.data.push([data[i].lat, data[i].lon]);
            }
            this.lstLat = data[0].lat;
            this.lstLon = data[0].lon;
          }
        } catch (error) {

        }
        this.done = true;
        this.$loading(false);
      });
    }
  },

};
</script>
